
<template>
  <div class="shopkeeper-help-pc">
    <div class="shopkeeper-help-top-box">
       <div class="shopkeeper-help-top-text">
        实体彩票店竞彩销量提升帮扶项目
       </div>
    </div>

    <div class="shopkeeper-help-box">
      <div class="shopkeeper-help-introduce">
        自2006年起，嘉彩科讯核心团队就在彩票行业进行探索性发展，亲身经历了我国彩票行业从小到大，再到总发行量达到世界第一的全部历程，同时也见证了我国彩票行业从业者从几万人发展到几十万人的光辉历程。自2015年开始，嘉彩科讯团队前身开始开展彩票网点经营能力提升帮扶项目，七年时间内，直接帮助近3000个月销三万元以下的低销量彩票网点实现了成倍、成十倍的增长，帮助上千个代销者从一个月收入不足2000元的低保人群 逐步发展成为年收入上百万的行业达人。通过对七年的实体店帮扶工作经验的总结，嘉彩团队提炼出了一整套实战性强、高效率的系统化彩票销售理念。为加快实现公司愿景，同时也为彩票销售渠道的有效拓展树立行业典范，嘉彩团队计划以加盟方式向商业渠道拓展中国体育彩票代理销售网点。
      </div>

      <div class="shopkeeper-help-example">
        <div class="shopkeeper-help-example-title">
          成功案例
        </div>
        <div class="shopkeeper-help-example-introduce">
          自2016年以来，嘉彩科讯市场帮扶团队先后在湖北襄阳、宜昌等八个地市开展彩票店经营能力提升项目，取得了骄人的成绩。之后公司业务发展到了江西、安徽、辽宁、陕西、山西、江苏、重庆七个省的22个地市/区，培养出了159个年销量过千万的明星店。
        </div>
        <div v-for="item in echartsList" :key="item.id" class="shopkeeper-help-example-item">
          <div class="shopkeeper-help-example-item-echarts" :id="`echarts${item.id}`"></div>
          <div class="shopkeeper-help-example-item-title">{{item.footerTitle}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'shopkeeper-help-pc',

  data () {
    return {
      echartsList: [
        {
          id: 1,
          title: '2021--2022苏州第一批30个网点销量变化',
          x: ['4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月', '1月'],
          xData: [882430, 1344566, 5352668, 7638012, 11463254, 9362586, 11950762, 12076384, 8903492, 8205320],
          barColor: '#ed7e30',
          footerTitle: '2021年5月苏州竞彩帮扶项目，25个网点平均单月销量增长10.21倍。'
        },
        {
          id: 2,
          title: '2020--2022吕梁第一批22个网点销量变化',
          x: ['签约前', '10月', '11月', '12月', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月', '1月'],
          xData: [579407, 761716, 2776684, 5592272, 10922678, 2708894, 7785618, 5890432, 9643208, 6743922, 6320754, 5843842, 5946206, 6120736, 7840842, 7965430, 5306218],
          barColor: '#5b9bd5',
          footerTitle: '2020年9月吕梁竞彩帮扶项目，22个网点平均单月销量增长11.07倍。'
        },
        {
          id: 3,
          title: '西安第一批17个有效网点销量变化',
          x: ['基数', '7月', '8月', '9月', '10月', '11月', '12月', '1月'],
          xData: [602135, 1536460, 3750964, 3477828, 2911918, 4469576, 4437278, 6594660],
          barColor: '#5c9bd5',
          footerTitle: '2020年7月西安竞彩店帮扶项目，17个网点平均单月销量增长9.43倍。'
        },
        {
          id: 4,
          title: '2021西安第一批30个短训帮扶网点销量',
          x: ['3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月'],
          xData: [679844, 1296046, 1906452, 6490244, 7381604, 6176260, 6067794, 5477582],
          barColor: '#4472c4',
          footerTitle: '2021年5月西安竞彩网点经营能力提升项目，30个网点平均单月销量增长9.86倍。'
        },
        {
          id: 5,
          title: '辽阳网点销量变化',
          x: ['基数', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月', '1月', '2月'],
          xData: [473422, 715094, 1725066, 2777290, 2813862, 3751936, 4635752, 4627634, 7370782, 5205810, 3768982, 4343624],
          barColor: '#ed7d31',
          footerTitle: '2021年4月辽阳竞彩店帮扶项目，32个竞彩店平均单月销量增长7.92倍。'
        },
        {
          id: 6,
          title: '赣州网点竞彩销量变化',
          x: ['3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          xData: [1926704, 6376408, 14509542, 19088020, 17386696, 16289024, 19907820, 13067038, 9249630, 17035264],
          barColor: '#4472c4',
          footerTitle: '2019年3月赣州竞彩店帮扶项目，先后126个签约网点总体销量增长8.79倍。'
        }
      ]
    }
  },

  mounted () {
    this.echartsList.forEach(item => {
      this.initEcharts(item)
    })
  },

  methods: {
    initEcharts (e) {
      const myChart = echarts.init(document.querySelector(`#echarts${e.id}`))
      // 绘制图表
      myChart.setOption({
        title: {
          text: e.title,
          textStyle: {
            color: '#595959',
            fontSize: '8vw'
          },
          left: 'center'
        },
        grid: {
          left: '80vw',
          right: 0
        },
        tooltip: {},
        xAxis: {
          data: e.x
        },
        yAxis: {},
        series: [
          {
            name: '销量',
            type: 'bar',
            data: e.xData,
            itemStyle: {
              color: e.barColor
            }
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.shopkeeper-help-pc {
  .shopkeeper-help-top-box {
    height: 96px;
    background: url('~@/assets/images/shopkeeper-top--m.png');
    background-size: auto 100%;
    padding: 25px 20px 0 20px;
    .shopkeeper-help-top-text {
      position: relative;
      font-size: 20px;
      font-family: PingFang SC-Medium, PingFang SC;
      color: #C52626;

      &::before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: -5px;
        width: 15px;
        height: 3px;
        background: #C52626;
      }
    }
  }

  .shopkeeper-help-box {
    padding: 15px 20px 64px;

    .shopkeeper-help-introduce {
      margin-bottom: 70px;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 35px;
    }

    .shopkeeper-help-example {
      .shopkeeper-help-example-title {
        margin-bottom: 10px;
        font-size: 15px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #000000;
        line-height: 18px;
      }

      .shopkeeper-help-example-introduce {
        margin-bottom: 34px;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        line-height: 35px;
      }

      .shopkeeper-help-example-item {
        margin-bottom: 45px;

        &:last-child {
          margin-bottom: none;
        }

        .shopkeeper-help-example-item-echarts {
          width: 335px;
          height: 300px;
          padding-top: 15px;
          border: 1px solid #d2d2d2;
        }

        .shopkeeper-help-example-item-title {
          margin-top: 10px;
          font-size: 10px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
          line-height: 25px;
        }
      }
    }
  }
}
</style>
